import styled from 'styled-components'
import { Style } from '../../styles'

export default styled.div`
	background-color: #fff;
	border-radius: 5px;
	border: 1px solid ${Style.color.border};
`